/**
 * 위젯 선택기 — EditorJS 메뉴에서 "위젯"으로 표시, 선택 시 해당 블록으로 교체
 * 공통 스타일: shared/style.scss (.ejs-widget)
 */
import { getAvailableSpecialBlocks } from './registry';

export default class SpecialBlockPickerTool {
  static get toolbox() {
    return {
      title: "위젯",
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l8 4.5v9l-8 4.5l-8 -4.5v-9l8 -4.5" /><path d="M12 12l8 -4.5" /><path d="M12 12v9" /><path d="M12 12l-8 -4.5" /></svg>'
    };
  }

  static get isReadOnlySupported() { return false; }

  constructor({ data, api, config }) {
    this.api = api;
    this.config = config || {};
    this.data = data || {};
    this.wrapper = null;
  }

  render() {
    this.wrapper = document.createElement("div");
    this._renderPicker();
    return this.wrapper;
  }

  _renderPicker() {
    const blocks = getAvailableSpecialBlocks({
      includePageWidgets: this.config.includePageWidgets || false
    });

    const entries = Object.entries(blocks);

    this.wrapper.className = "ejs-widget ejs-widget--picker";
    this.wrapper.style.cssText = "";
    this.wrapper.innerHTML = `
      <p style="text-align: center; font-size: 12px; margin: 0 0 12px 0;" class="ejs-widget__hint">삽입할 위젯을 선택하세요</p>
      <div style="display: flex; flex-direction: column; gap: 6px;">
        ${entries.map(([key, block]) => `
          <div class="ejs-widget__result-item" data-block="${key}" style="display: flex; align-items: center; gap: 12px;">
            <div style="flex-shrink: 0;" class="ejs-widget__hint">${block.icon}</div>
            <div style="flex: 1; min-width: 0;">
              <p style="font-size: 14px; font-weight: 500; margin: 0;">${block.title}</p>
              <p style="font-size: 12px; margin: 2px 0 0 0;" class="ejs-widget__hint">${block.description}</p>
            </div>
            <div style="flex-shrink: 0;" class="ejs-widget__hint">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6l-6 6" /></svg>
            </div>
          </div>
        `).join('')}
      </div>
    `;

    this.wrapper.querySelectorAll('[data-block]').forEach(item => {
      item.addEventListener('click', (e) => {
        e.stopPropagation();
        this._selectBlock(item.dataset.block);
      });
    });
  }

  _selectBlock(blockKey) {
    const currentIndex = this.api.blocks.getCurrentBlockIndex();
    this.api.blocks.delete(currentIndex);
    this.api.blocks.insert(blockKey, {}, undefined, currentIndex, true);
  }

  save() { return {}; }
  validate() { return false; }
}
